import { TGetBudgetFlowNode } from '../decoder'

export const makeSetBudgetFlowNodeEncoder = () => (nodeValue: TGetBudgetFlowNode) => nodeValue.toJS()
